import { Star, Sparkles } from 'lucide-react';

// Badge definitions
export const BADGE_DEFINITIONS = {
  218: {
    id: 218,
    name: 'Weekly Trace Star',
    icon: Star,
    color: '#F59E0B', // Warm amber
    bgColor: '#FEF3C7', // Light amber background
    borderColor: '#F59E0B',
    glowColor: '#FDE68A', // Softer amber glow
    hasGlow: true
  },
  219: {
    id: 219,
    name: 'Monthly Trace Star',
    icon: Sparkles,
    color: '#6366F1', // Indigo
    bgColor: '#E0E7FF', // Light indigo background
    borderColor: '#6366F1',
    glowColor: '#A5B4FC', // Softer indigo glow
    hasGlow: true
  }
};

// Helper function to get badge by ID
export const getBadge = badgeId => {
  return BADGE_DEFINITIONS[badgeId] || null;
};
